import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Button, Checkbox, Modal } from 'fr-shared/components';

const CommercialInvoiceModal = ({ lineItems, onGenerate, loading, disabled }) => {
  const [details, setDetails] = useState({});
  const [importerSameAsConsignee, setImporterSameAsConsignee] = useState(true);
  const [importer, setImporter] = useState('');
  const [additionalInformation, setAdditionalInformation] = useState('');

  const handleChange = (id, field, value) => {
    setDetails(prev => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));
  };

  return (
    <Modal
      action={
        <Button color="primary" className="mx-2" disabled={disabled}>
          Generate Commercial Invoice
        </Button>
      }
      className="modal-scrollable commercial-invoice-modal"
    >
      {({ toggle }) => (
        <>
          <Modal.Header title="Commercial Invoice Details" onClose={toggle} />
          <Modal.Body>
            <p className="text-muted">
              Enter the Description of Goods and HS Code for each line item being shipped.
            </p>
            {lineItems.map(li => (
              <div key={li.order_line_item_id} className="border-bottom pb-3 mb-3">
                <strong>{li.description}</strong>
                <div className="row mt-2">
                  <div className="col-md">
                    <label>Description of Goods</label>
                    <input
                      className="form-control"
                      value={details[li.order_line_item_id]?.description || ''}
                      onChange={e =>
                        handleChange(li.order_line_item_id, 'description', e.target.value)
                      }
                    />
                  </div>
                  <div className="col-md">
                    <label>HS Code</label>
                    <input
                      className="form-control"
                      value={details[li.order_line_item_id]?.hs_code || ''}
                      onChange={e =>
                        handleChange(li.order_line_item_id, 'hs_code', e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            ))}

            <div className="border-bottom pb-3 mb-3">
              <Checkbox
                name="importer_same_as_consignee"
                label="Importer is same as consignee"
                value={importerSameAsConsignee}
                onChange={e => setImporterSameAsConsignee(e.target.checked)}
              />
              {!importerSameAsConsignee && (
                <div className="mt-2">
                  <label>Importer (complete name, address and telephone)</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    value={importer}
                    onChange={e => setImporter(e.target.value)}
                  />
                </div>
              )}
            </div>

            <div>
              <label>Additional Information</label>
              <textarea
                className="form-control"
                rows={3}
                value={additionalInformation}
                onChange={e => setAdditionalInformation(e.target.value)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              color="primary"
              loading={loading}
              onClick={() =>
                onGenerate({
                  lineItemDetails: details,
                  importer: importerSameAsConsignee ? null : importer,
                  additionalInformation,
                }).then(() => toggle())
              }
            >
              Generate
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

CommercialInvoiceModal.propTypes = {
  lineItems: PropTypes.arrayOf(
    PropTypes.shape({
      order_line_item_id: PropTypes.number.isRequired,
      description: PropTypes.string,
    })
  ).isRequired,
  onGenerate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CommercialInvoiceModal;
